import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { toastAction } from "assets/properties/properties";
import { commonButton } from "assets/properties/properties";
import { pinCodeData } from "assets/properties/properties";

  
const PincodeCreate = (props) => {
  const navigate = useNavigate();

  const [pincodes, setPinCodes] = useState("");
  const [pincodesState, setPinCodesState] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const { classes } = props;

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (pincodes === "") {

    setPinCodesState(true);
    return false;
    }else{
      return true;
    }

  };

  const handlecreatepincodeSubmit = async (event) => {
    if (isValidated()) {
      toastUpdate("", "", false);
      setCallInProgress(true);
      // MASTER_PINCODE_ADDBULK
      const res = await apiHandler({
        url: endpoint.MASTER_PINCODE_ADDBULK,
        method: "POST",
        authToken: authToken,
        data: {
          pincodes: [pincodes],
        },
      });
      setCallInProgress(false);
      //this.setState({ callInProgress: false });
     if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
        return;
      } else {
        toastUpdate(toastAction?.success, pinCodeData?.successMsg, true);
        setRedirectURL(pinCodeData?.mainUrl);
      }
    }
  };
  const handlecancelpincode = () => {
    navigate(pinCodeData?.mainUrl);
  };
  const handlePinCode = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setPinCodes(e);
    }
  };
  return (
    <Grid container>
    <Grid item xs={12} sm={12} md={12}>
      <SubHeader
        label={pinCodeData?.button}
        button1={commonButton?.button1}
        button2={commonButton?.button2}
        disabled1={pincodes?.length !==6 ? true: false}
        button1click={handlecreatepincodeSubmit}
        button2click={handlecancelpincode}
      />
    </Grid>

    <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
             <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="PinCode"
              required
              error={pincodesState}
              id="lp_branch_code"
              value={pincodes || ''}
              setState={handlePinCode}
              type="code"
              maxLength="6"
            />
          </Grid>
          </Grid>
          </Grid>     
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
       </Grid>
  );
};

PincodeCreate.propTypes = {
  classes: PropTypes.object,
};

export default PincodeCreate;
